module.exports = __webpack_public_path__ + "media/stylesheets/images/talentz/kv_txt01-ab90dcc283c35b524747cf7d0d5834e2.svg";